var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileLine = function SvgFileLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.75 2.502V2.5h8.248c.415 0 .752.341.752.744v13.512a.744.744 0 0 1-.745.744H3.995a.75.75 0 0 1-.745-.755V7zM5.373 7H7.75V4.622zM9.25 4v3.75a.75.75 0 0 1-.75.75H4.75V16h10.5V4z"
  })));
};
export default SvgFileLine;